export default __webpack_public_path__ + "static/media/bell.b54f156f.svg";